import { compose } from 'redux';

import { createUsersMiddleware } from './users.middleware';
import { createProjectsMiddleware } from './projects.middleware';
import { createMenuMiddleware } from './menu.middleware';
import { createEnvironmentsMiddleware } from './environments.middleware';
import { createActivitiesMiddleware } from './activities.middleware';
import { createPackagesMiddleware } from './packages.middleware';
import { createDashboardMiddleware } from './dashboard.middleware';
import { createDatabasesMiddleware } from './databases.middleware';
import { createCommandsMiddleware } from './commands.middleware';
import { createProjectMiddleware } from './project.middleware';
import { createEnumsMiddleware } from './enums.middleware';
import { createSecurityMiddleware } from './security.middleware';
import { createScriptsMiddleware } from './scripts.middleware';
import { createJobsMiddleware } from './jobs.middleware';
import { createFilesMiddleware } from './files.middleware';
import { createLogsMiddleware } from './logs.middleware';
import { createReportsMiddleware } from './reports.middleware';
import { createCmsMiddleware } from './cms.middleware';
import { createPolicyEngineMiddleware } from './policy-engine.middleware';
import { createTagTypesMiddleware } from './tag-types.middleware';
import { createTagsMiddleware } from './tags.middleware';
import { createLicenseMiddleware } from './license.middleware';
import { createHooksMiddleware } from './hooks.middleware';
import { createBackupsMiddleware } from './backups.middleware';

import { SessionService } from '@src/services';
import { createAdminMiddleware } from '@src/store/middlewares/admin.middleware';
import { createVaultMiddleware } from '@src/store/middlewares/vault.middleware';
import { createAgentMiddleware } from '@src/store/middlewares/agent.middleware';
import { createChatbotMiddleware } from '@src/store/middlewares/chatbot.middleware';

const composeEnhancers = window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose;

export const getMiddlewares = (http: any, sessionService: SessionService, translate: any, dialogManagerService: any) => {
    const successPopUp = (success: any) => {
        if (!success) {
            success = { message: '', text: '', secondDialog: false };
        }
        dialogManagerService.showSuccessDialog({ title: success.message, text: success.text,
            secondDialog: success.secondDialog });
    };
    const errorPopUp = async (error: any) => {
        const message = await translate('ERROR_OCCURRED');
        if (!error) {
            error = { message, text: '', secondDialog: false };
        }
        dialogManagerService.showErrorDialog({ title: error.message, text: error.text,
            secondDialog: error.secondDialog });
    };

    return composeEnhancers(
        createSecurityMiddleware(http, successPopUp),
        createUsersMiddleware(http, successPopUp, errorPopUp),
        createProjectsMiddleware(http, sessionService),
        createMenuMiddleware(http),
        createEnvironmentsMiddleware(http),
        createActivitiesMiddleware(http),
        createPackagesMiddleware(http, successPopUp),
        createDashboardMiddleware(http),
        createDatabasesMiddleware(http),
        createCommandsMiddleware(http),
        createProjectMiddleware(http, sessionService),
        createEnumsMiddleware(http),
        createScriptsMiddleware(http),
        createJobsMiddleware(http),
        createFilesMiddleware(http),
        createLogsMiddleware(http),
        createBackupsMiddleware(http),
        createReportsMiddleware(http),
        createCmsMiddleware(http, successPopUp, errorPopUp),
        createPolicyEngineMiddleware(http, successPopUp),
        createTagTypesMiddleware(http, successPopUp, errorPopUp),
        createTagsMiddleware(http),
        createLicenseMiddleware(http, translate, successPopUp),
        createHooksMiddleware(http, successPopUp),
        createAdminMiddleware(http),
        createVaultMiddleware(http, successPopUp, errorPopUp),
        createChatbotMiddleware(http, successPopUp, errorPopUp),
        createAgentMiddleware(http, successPopUp, errorPopUp)
    );
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/index.ts